import { useState } from "react"
import Chevron from "@/common/icons/chevron"
import Blocks from "@/components/Blocks"
import Block from "@/components/wrappers/block"
import styles from "./accordion.module.css"
import classNames from "classnames"

export default function Item({ block, settings }) {
  const [hidden, setHidden] = useState(true)
  const { attrs, innerBlocks } = block
  const { heading } = attrs

  if (innerBlocks.length === 0 || !heading) {
    return null
  }

  const classes = [styles.item, "accordion", settings?.innerAlign].concat(
    block.attrs.classList
  )

  const childSettings = {
    "core/buttons": { width: "bleed" },
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "core/list": { width: "bleed" },
    "core/image": { width: "bleed" },
    "core/quote": { width: "bleed" }
  }

  return (
    <Block
      id={block.attrs?.slug}
      block={block}
      width="bleed"
      gap="none"
      className={classNames(classes)}>
      <header
        onClick={() => setHidden(!hidden)}
        role="button"
        aria-expanded={!hidden}
        aria-pressed={!hidden}>
        <h2>{block.attrs.heading}</h2>
        <div className="toggle">
          <Chevron className={classNames({ "is-open": !hidden })} />
        </div>
      </header>
      <div
        className={classNames("content", {
          "hidden on-print": hidden
        })}>
        <Blocks blocks={innerBlocks} settings={childSettings} />
      </div>
    </Block>
  )
}
